import { Type } from '@sinclair/typebox';
import { cartAddressSchema, cartBillingAddressSchema } from "../cart/customer.mjs";
import { baseCommandSchema } from "./shared.mjs";
export const setShoutCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('setShout'),
        orderId: Type.String(),
        handle: Type.String(),
        permission: Type.Boolean(),
    }),
]);
export const setEmailCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('setEmail'),
        email: Type.String(),
    }),
]);
export const setPhoneNumberCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('setPhoneNumber'),
        phoneNumber: Type.String(),
    }),
]);
export const setCompanyNameCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('setCompanyName'),
        companyName: Type.String(),
    }),
]);
export const setIsCompanyCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('setIsCompany'),
        isCompany: Type.Boolean(),
    }),
]);
export const setVatNumberCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('setVatNumber'),
        vatNumber: Type.String(),
    }),
]);
const cartCommandAddressSchema = Type.Omit(cartAddressSchema, ['isValid']);
const cartCommandBillingAddressSchema = Type.Omit(cartBillingAddressSchema, ['isValid']);
export const setAddressCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('setAddress'),
        address: cartCommandAddressSchema,
    }),
]);
export const setBillingAddressCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('setBillingAddress'),
        address: cartCommandBillingAddressSchema,
    }),
]);
export const setUseBillingAddressCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('setUseBillingAddress'),
        useBillingAddress: Type.Boolean(),
    }),
]);
export const setReferenceCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('setReference'),
        reference: Type.String(),
    }),
]);
export const setCommentCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('setComment'),
        comment: Type.Optional(Type.String()),
    }),
]);
//# sourceMappingURL=customer.js.map